var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},[_c('div',{staticClass:"tabs__list"},_vm._l((_vm.tabs),function(item){return _c('MyTextUnderlineBtn',{key:item.keyword,attrs:{"labelText":item.title,"active":_vm.isActiveTab(item.keyword)},on:{"click":function($event){return _vm.$emit('set-tab', item.keyword)}}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }